import CategoriesWrapper from "../pages/categories";
import CategoriesListWrapper from "../pages/categories/list/CategoriesListWrapper";
import DashboardWrapper from "../pages/dashboard";
import DashboardView from "../pages/dashboard/views/DashboardView";
import HeadquartersWrapper from "../pages/headquarters";
import HeadquartersListWrapper from "../pages/headquarters/list/HeadquartersListWrapper";
import HeadquarterProfileLayout from "../pages/headquarters/profile/HeadquarterProfileLayout";
import HeadquarterInfo from "../pages/headquarters/profile/views/info/HeadquaterInfo";
import HeadquarterAssets from "../pages/headquarters/profile/views/assets/HeadquarterAssets";
import HeadquarterPickupsWrapper from "../pages/headquarters/profile/views/pickups/HeadquarterPickupsWrapper";
import HeadquarterProduct from "../pages/headquarters/profile/views/products/HeadquarterProduct";
import MaintenancesWrapper from "../pages/maintenances";
import MaintenancesListWrapper from "../pages/maintenances/list/MaintenancesListWrapper";
import OrganisationWrapper from "../pages/organisations";
import OrganisationCreate from "../pages/organisations/create/OrganisationCreate";
import OrganisationEdit from "../pages/organisations/edit/OrganisationEdit";
import OrganisationsListWrapper from "../pages/organisations/list/OrganisationsListWrapper";
import PickupsWrapper from "../pages/pickups";
import GlobalMessagesWrapper from "../pages/pickups/globalMessages";
import PickupGlobalMessagesWrapper from "../pages/pickups/globalMessages/PickupGlobalMessagesWrapper";
import PickupsListWrapper from "../pages/pickups/list/PickupsListWrapper";
import DriverMobileView from "../pages/pickups/myPickups";
import PickupProfileLayout from "../pages/pickups/profile/PickupProfileLayout";
import PickupInfo from "../pages/pickups/profile/views/info/PickupInfo";
import PickupProducts from "../pages/pickups/profile/views/products/PickupProducts";
import PickupStatusHistoryWrapper from "../pages/pickups/profile/views/statusHistory/PickupStatusHistoryWrapper";
import ProductsWrapper from "../pages/products";
import ProductsListWrapper from "../pages/products/list/ProductsListWrapper";
import ProductProfileLayout from "../pages/products/profile/ProductProfileLayout";
import ProductInfo from "../pages/products/profile/views/info/ProductInfo";
import ProductStockMovementsWrapper from "../pages/products/profile/views/stockmovements/ProductStockMovementsWrapper";
import ProvidersWrapper from "../pages/providers";
import ProvidersListWrapper from "../pages/providers/list/ProvidersListWrapper";
import ProviderProfileLayout from "../pages/providers/profile/ProviderProfileLayout";
import ProviderHeadquarters from "../pages/providers/profile/views/headquarters/ProviderHeadquarters";
import ProviderInfo from "../pages/providers/profile/views/info/ProviderInfo";
import ProvidersInvoicesWrapper from "../pages/providersInvoices";
import ProvidersInvoicesListWrapper from "../pages/providersInvoices/list/ProvidersInvoicesListWrapper";
import ProviderInvoiceProfileLayout from "../pages/providersInvoices/profile/ProvidersInvoicesLayout";
import ProviderInvoicesInfo from "../pages/providersInvoices/profile/views/info/ProviderInvoicesInfo";
import ProviderTypesWrapper from "../pages/providerTypes";
import ProviderTypesListWrapper from "../pages/providerTypes/list/ProviderTypesListWrapper";
import RefuelsWrapper from "../pages/refuels";
import RefuelsListWrapper from "../pages/refuels/list/RefuelsListWrapper";
import RolesWrapper from "../pages/roles";
import RoleCreate from "../pages/roles/create/RoleCreate";
import RoleEdit from "../pages/roles/edit/RoleEdit";
import RolesListWrapper from "../pages/roles/list/RolesListWrapper";
import RoutesWrapper from "../pages/routes";
import RoutesListWrapper from "../pages/routes/list/RoutesListWrapper";
import RouteProfileLayout from "../pages/routes/profile/RouteProfileLayout";
import RouteHeadquarters from "../pages/routes/profile/views/headquarters/RouteHeadquarters";
import RouteInfo from "../pages/routes/profile/views/info/RouteInfo";
import StockMovementsWrapper from "../pages/stockMovements";
import StockMovementsListWrapper from "../pages/stockMovements/list/StockMovementsListWrapper";
import UnitsMeasureWrapper from "../pages/unitsMeasure";
import UnitsMeasureListWrapper from "../pages/unitsMeasure/list/UnitsMeasureListWrapper";
import UsersWrapper from "../pages/users";
import UserEditPermissions from "../pages/users/edit/UserEditPermissions";
import UsersListWrapper from "../pages/users/list/UsersListWrapper";
import UserProfileLayout from "../pages/users/profile/UserProfileLayout";
import UserDocuments from "../pages/users/profile/views/documents/UserDocuments";
import UserInfo from "../pages/users/profile/views/info/UserInfo";
import UserPermissions from "../pages/users/profile/views/permissions/UserPermissions";
import VehiclesWrapper from "../pages/vehicles";
import VehiclesListWrapper from "../pages/vehicles/list/VehiclesListWrapper";
import VehicleProfileLayout from "../pages/vehicles/profile/VehicleProfileLayout";
import VehicleInfo from "../pages/vehicles/profile/views/info/VehicleInfo";
import VehicleMaintenanceWrapper from "../pages/vehicles/profile/views/maintenance/VehicleMaintenanceWrapper";
import VehicleRefuelingWrapper from "../pages/vehicles/profile/views/refueling/VehicleRefuelingWrapper";
import WorkHoursWrapper from "../pages/workHours";
import WorkHoursListWrapper from "../pages/workHours/list/WorkHoursListWrapper";
import { menuRoutes } from "./menu";
import ClientsWrapper from "../pages/clients";
import ClientsListWrapper from "../pages/clients/list/ClientsListWrapper";
import ClientProfileLayout from "../pages/clients/profile/ClientProfileLayout";
import ClientInfo from "../pages/clients/profile/info/ClientInfo";
import InvoicesWrapper from "../pages/invoices";
import InvoicesListWrapper from "../pages/invoices/list/InvoicesListWrapper";
import InvoiceProfileLayout from "../pages/invoices/profile/InvoiceProfileLayout";
import InvoiceInfo from "../pages/invoices/profile/info/InvoiceInfo";
import ConfigWrapper from "../pages/config";
import ConfigListWrapper from "../pages/config/list/ConfigListWrapper";
import ClientInvoices from "../pages/clients/profile/invoices/ClientInvoices";
import GeneralExpensesWrapper from "../pages/generalExpense";
import GeneralExpenseListWrapper from "../pages/generalExpense/list/GeneralExpenseListWrapper";

const protectedRoutes = [

	/******************************************************
	 * Dashboard
	 * ******************************************************/

	{
		path: menuRoutes.dashboard.path,
		element: <DashboardWrapper />,
		sub: [
			{
				element: <DashboardView />,
				access: {
					group: "dashboard",
					action: "get",
				},
				index: true,
			}
		],
	},

	/******************************************************
	 * Organisations
	 ******************************************************/
	{
		path: menuRoutes.organisations.path,
		element: <OrganisationWrapper />,
		sub: [
			{
				element: <OrganisationsListWrapper />,
				access: {
					group: "company",
					action: "list",
				},
				index: true,
			},
			{
				element: <OrganisationCreate />,
				path: menuRoutes.organisations.create,
				access: {
					group: "company",
					action: "create"
				}
			},
			{
				element: <OrganisationEdit />,
				path: ':id/edit',
				access: {
					group: "company",
					action: "edit"
				}
			}
		],
	},

	/******************************************************
	 * Providers
	 ******************************************************/
	{
		path: menuRoutes.providers.path,
		element: <ProvidersWrapper />,
		sub: [
			{
				element: <ProvidersListWrapper />,
				access: {
					group: 'provider',
					action: 'list'
				},
				index: true,
			},
			{
				element: <ProviderProfileLayout />,
				path: menuRoutes.providers.profile.path,
				access: {
					group: 'provider',
					action: 'get'
				},
				sub: [
					{
						element: <ProviderInfo />,
						path: menuRoutes.providers.profile.info,
						access: {
							group: 'provider',
							action: 'get'
						}
					},
					{
						element: <ProviderHeadquarters />,
						path: menuRoutes.providers.profile.headquarters,
						access: {
							group: 'headquarter',
							action: 'list'
						}
					},
				]
			},
		]
	},

    /******************************************************
     * Clients
     ******************************************************/
    {
        path: menuRoutes.clients.path,
        element: <ClientsWrapper />,
        sub: [
            {
                element: <ClientsListWrapper />,
                access: {
                    group: 'client',
                    action: 'list'
                },
                index: true,
            },
            {
                element: <ClientProfileLayout />,
                path: menuRoutes.clients.profile.path,
                access: {
                    group: 'client',
                    action: 'get'
                },
                sub: [
                    {
                        element: <ClientInfo />,
                        path: menuRoutes.clients.profile.info,
                        access: {
                            group: 'client',
                            action: 'get'
                        },
                    },
                    {
                        element: <ClientInvoices type="proforma" />,
                        path: menuRoutes.clients.profile.proformas,
                        access: {
                            group: 'invoice',
                            action: 'list'
                        },
                    },
                    {
                        element: <ClientInvoices type="invoice" />,
                        path: menuRoutes.clients.profile.facturas,
                        access: {
                            group: 'invoice',
                            action: 'list'
                        },
                    }
                ]
            }
        ]
    },

    /******************************************************
     * General Expenses
     ******************************************************/
    {
        path: menuRoutes.generalExpenses.path,
        element: <GeneralExpensesWrapper />,
        sub: [
            {
                element: <GeneralExpenseListWrapper />,
                access: {
                    group: 'general_expense',
                    action: 'list'
                },
                index: true,
            }
        ]
    },

    /******************************************************
     * Invoices (Proformas and Facturas)
     ******************************************************/
    {
        path: menuRoutes.invoices.proformas,
        element: <InvoicesWrapper />,
        sub: [
            {
                element: <InvoicesListWrapper type="proforma" />,
                access: {
                    group: 'invoice',
                    action: 'list'
                },
                index: true,
            },
        ]
    },
    {
        path: menuRoutes.invoices.facturas,
        element: <InvoicesWrapper />,
        sub: [
            {
                element: <InvoicesListWrapper type="invoice" />,
                access: {
                    group: 'invoice',
                    action: 'list'
                },
                index: true,
            },
        ]
    },
    {
        path: menuRoutes.invoices.path,
        element: <InvoicesWrapper />,
        sub: [
            {
                element: <InvoiceProfileLayout />,
                path: menuRoutes.invoices.profile.path,
                access: {
                    group: 'invoice',
                    action: 'get'
                },
                sub: [
                    {
                        element: <InvoiceInfo />,
                        path: menuRoutes.invoices.profile.info,
                        access: {
                            group: 'invoice',
                            action: 'get'
                        },
                    },
                ]
            }
        ]
    },

	/******************************************************
	 * Roles
	 ******************************************************/
	{
		path: menuRoutes.roles.path,
		element: <RolesWrapper />,
		sub: [
			{
				element: <RolesListWrapper />,
				access: {
					group: 'role',
					action: 'list'
				},
				index: true,
			},
			{
				element: <RoleCreate />,
				path: menuRoutes.roles.create,
				access: {
					group: 'role',
					action: 'create'
				}
			},
			{
				element: <RoleEdit />,
				path: menuRoutes.roles.edit,
				access: {
					group: 'role',
					action: 'edit'
				}
			},
		]
	},

	/******************************************************
	 * Users
	 ******************************************************/
	{
		path: menuRoutes.users.path,
		element: <UsersWrapper />,
		sub: [
			{
				element: <UsersListWrapper />,
				access: {
					group: 'user',
					action: 'list'
				},
				index: true,
			},
			{
				element: <UserProfileLayout />,
				path: menuRoutes.users.profile.path,
				access: {
					group: 'user',
					action: 'get'
				},
				sub: [
					{
						element: <UserInfo />,
						path: menuRoutes.users.profile.info,
						access: {
							group: 'user',
							action: 'get'
						},
					},
					{
						element: <UserDocuments />,
						path: menuRoutes.users.profile.documents,
						access: {
							group: 'user',
							action: 'get'
						},
					},
					{
						element: <UserPermissions />,
						path: menuRoutes.users.profile.permissions,
						access: {
							group: 'user',
							action: 'get_permissions'
						},
					},
				]
			},
			{
				element: <UserEditPermissions />,
				path: menuRoutes.users.edit_permissions,
				access: {
					group: 'user',
					action: 'edit_permissions'
				}
			},
		]
	},

	/******************************************************
	 * WorkHours
	 ******************************************************/
	{
		path: menuRoutes.workHours.path,
		element: <WorkHoursWrapper />,
		sub: [
			{
				element: <WorkHoursListWrapper />,
				access: {
					group: 'work_hour',
					action: 'list'
				},
				index: true,
			},
		]
	},
	/******************************************************
	 * ProviderTypes
	 ******************************************************/
	{
		path: menuRoutes.providerTypes.path,
		element: <ProviderTypesWrapper />,
		sub: [
			{
				element: <ProviderTypesListWrapper />,
				access: {
					group: 'provider_type',
					action: 'list'
				},
				index: true,
			}
		]
	},

	/******************************************************
	 * Products
	 ******************************************************/
	{
		path: menuRoutes.products.path,
		element: <ProductsWrapper />,
		sub: [
			{
				element: <ProductsListWrapper />,
				access: {
					group: 'product',
					action: 'list'
				},
				index: true,
			},
			{
				element: <ProductProfileLayout />,
				path: menuRoutes.products.profile.path,
				access: {
					group: 'product',
					action: 'get'
				},
				sub: [
					{
						element: <ProductInfo />,
						path: menuRoutes.products.profile.info,
						access: {
							group: 'product',
							action: 'get'
						},
					},
					{
						element: <ProductStockMovementsWrapper />,
						path: menuRoutes.products.profile.stockMovements,
						access: {
							group: 'stock_movements',
							action: 'list'
						},
					},
				]
			},
		]
	},
	/******************************************************
	 * Categories
	 ******************************************************/
	{
		path: menuRoutes.categories.path,
		element: <CategoriesWrapper />,
		sub: [
			{
				element: <CategoriesListWrapper />,
				access: {
					group: 'category',
					action: 'list'
				},
				index: true,
			}
		]
	},
	/******************************************************
	 * Units
	 ******************************************************/
	{
		path: menuRoutes.units.path,
		element: <UnitsMeasureWrapper />,
		sub: [
			{
				element: <UnitsMeasureListWrapper />,
				access: {
					group: 'unit_measure',
					action: 'list'
				},
				index: true,
			}
		]
	},
	/******************************************************
	 * stock movements
	 ******************************************************/
	{
		path: menuRoutes.stockMovements.path,
		element: <StockMovementsWrapper />,
		sub: [
			{
				element: <StockMovementsListWrapper />,
				access: {
					group: 'stock_movements',
					action: 'list'
				},
				index: true,
			}
		]
	},

	/******************************************************
	 * Headquarters
	******************************************************/
	{
		path: menuRoutes.headquarters.path,
		element: <HeadquartersWrapper />,
		sub: [
			{
				element: <HeadquartersListWrapper />,
				access: {
					group: 'headquarter',
					action: 'list'
				},
				index: true,
			},
			{
				element: <HeadquarterProfileLayout />,
				path: menuRoutes.headquarters.profile.path,
				access: {
					group: 'headquarter',
					action: 'get'
				},
				sub: [
					{
						element: <HeadquarterInfo />,
						path: menuRoutes.headquarters.profile.info,
						access: {
							group: 'headquarter',
							action: 'get'
						},
					},
					{
						element: <HeadquarterAssets />,
						path: menuRoutes.headquarters.profile.assets,
						access: {
							group: 'headquarter',
							action: 'get'
						}
					},
					{
						element: <HeadquarterProduct />,
						path: menuRoutes.headquarters.profile.products,
						access: {
							group: 'provider_headquarter_recurrent_products',
							action: 'list'
						},
					},
					{
						element: <HeadquarterPickupsWrapper />,
						path: menuRoutes.headquarters.profile.pickups,
						access: {
							group: 'pickup',
							action: 'list'
						},
					}
				]
			},
		]
	},
	/******************************************************
	 * ProvidersInvoices
	 ******************************************************/
	{
		path: menuRoutes.providersInvoices.path,
		element: <ProvidersInvoicesWrapper />,
		sub: [
			{
				element: <ProvidersInvoicesListWrapper />,
				access: {
					group: 'provider_invoicing',
					action: 'list'
				},
				index: true,
			},
			{
				element: <ProviderInvoiceProfileLayout />,
				path: menuRoutes.providersInvoices.profile.path,
				access: {
					group: 'provider_invoicing',
					action: 'get'
				},
				sub: [
					{
						element: <ProviderInvoicesInfo />,
						path: menuRoutes.providersInvoices.profile.info,
						access: {
							group: 'provider_invoicing',
							action: 'get'
						},
					},
				]
			},
		]
	},

	/******************************************************
	 * Vehicles
	 ******************************************************/
	{
		path: menuRoutes.vehicles.path,
		element: <VehiclesWrapper />,
		sub: [
			{
				element: <VehiclesListWrapper />,
				access: {
					group: 'vehicle',
					action: 'list'
				},
				index: true,
			},
			{
				element: <VehicleProfileLayout />,
				path: menuRoutes.vehicles.profile.path,
				access: {
					group: 'vehicle',
					action: 'get'
				},
				sub: [
					{
						element: <VehicleInfo />,
						path: menuRoutes.vehicles.profile.info,
						access: {
							group: 'vehicle',
							action: 'get'
						},
					},
					{
						element: <VehicleRefuelingWrapper />,
						path: menuRoutes.vehicles.profile.refueling,
						access: {
							group: 'vehicle',
							action: 'get'
						},
					},
					{
						element: <VehicleMaintenanceWrapper />,
						path: menuRoutes.vehicles.profile.maintenance,
						access: {
							group: 'vehicle',
							action: 'get'
						},
					},
				]
			},
		]
	},

	/******************************************************
	 * Maintenances
	 ******************************************************/
	{
		path: menuRoutes.maintenances.path,
		element: <MaintenancesWrapper />,
		sub: [
			{
				element: <MaintenancesListWrapper />,
				access: {
					group: 'maintenance',
					action: 'list'
				},
				index: true,
			},
		]
	},

	/******************************************************
	 * Refuels
	 ******************************************************/
	{
		path: menuRoutes.refuels.path,
		element: <RefuelsWrapper />,
		sub: [
			{
				element: <RefuelsListWrapper />,
				access: {
					group: 'refuel',
					action: 'list'
				},
				index: true,
			},
		]
	},

	/******************************************************
	 * Routes
	 ******************************************************/
	{
		path: menuRoutes.routes.path,
		element: <RoutesWrapper />,
		sub: [
			{
				element: <RoutesListWrapper />,
				access: {
					group: 'route',
					action: 'list'
				},
				index: true,
			},
			{
				element: <RouteProfileLayout />,
				path: menuRoutes.routes.profile.path,
				access: {
					group: 'route',
					action: 'get'
				},
				sub: [
					{
						element: <RouteInfo />,
						path: menuRoutes.routes.profile.info,
						access: {
							group: 'route',
							action: 'get'
						},
					},
					{
						element: <RouteHeadquarters />,
						path: menuRoutes.routes.profile.headquarters,
						access: {
							group: 'route',
							action: 'get'
						},
					}
				]
			},
		]
	},

	/******************************************************
	 * Pickups
	 ******************************************************/
	{
		path: menuRoutes.pickups.path,
		element: <PickupsWrapper />,
		sub: [
			{
				element: <PickupsListWrapper />,
				access: {
					group: 'pickup',
					action: 'list'
				},
				index: true,
			},
			{
				element: <PickupProfileLayout />,
				path: menuRoutes.pickups.profile.path,
				access: {
					group: 'pickup',
					action: 'get'
				},
				sub: [
					{
						element: <PickupInfo />,
						path: menuRoutes.pickups.profile.info,
						access: {
							group: 'pickup',
							action: 'get'
						},
					},
					{
						element: <PickupProducts />,
						path: menuRoutes.pickups.profile.products,
						access: {
							group: 'pickup',
							action: 'get'
						},
					},
					{
						element: <PickupStatusHistoryWrapper />,
						path: menuRoutes.pickups.profile.statusHistory,
						access: {
							group: 'pickup',
							action: 'get'
						},
					}
				]
			},
		]
	},
	{
		path: menuRoutes.myPickups.path,
		element: <DriverMobileView />,
		access: {
			group: 'pickup',
			action: 'view_assigned'
		},

	},
	{
		path: menuRoutes.pickupsMessages.path,
		element: <GlobalMessagesWrapper />,
		sub: [
			{
				element: <PickupGlobalMessagesWrapper />,
				access: {
					group: 'pickup_global_messages',
					action: 'list'
				},
				index: true,
			},
		]
	},

	/******************************************************
	 * Config
	 ******************************************************/
	{
		path: menuRoutes.config.path,
		element: <ConfigWrapper />,
		sub: [
			{
				element: <ConfigListWrapper />,
				access: {
					group: 'config',
					action: 'list'
				},
				index: true,
			},
		]
	},
];

const contents = [...protectedRoutes];
export default contents;